import React from 'react';
import ReactDOM from 'react-dom/client';
import BordKaartenSingleKaart from './BordKaartenSingleKaart.js';
import KaartenPlaceholder from './placeholders/Kaarten.js';
import { getTemplate, getKaarten } from '../utils/query.js';
import $ from 'jquery';

var timestampLastUpdate;

// TEST: click voor update triggers opvolgen in development omgeving
if (process.env.NODE_ENV === "development") {
	$(function(){
		$(document).on('click', '.kaart-refresh', function(){
			console.log('click op kaart-refresh, simuleer refresh voor kaart ' + $(this).data('id'))
			$('#kaart-' + $(this).data('id')).trigger('ds-crm-react-update')
		})
		$(document).on('click', '#refresh-alle-kaarten', function(){
			console.log('click op refresh-alles, alles verversen')
			$('#lijst-' + $(this).data('id')).trigger('ds-crm-react-full-update');
		})
	})
}

export default class BordKaarten extends React.Component {
	state = {
		kaarten: [],
		template: '',
		loading: true,
		debug: false,
	}

	componentDidMount(){
		// Template eenmalig ophalen
		getTemplate( 'bord-single-kaart' )
			.then(json => {
				this.setState({ template: json });
			});

		this.restRequest();

		this.fullUpdate = this.fullUpdate.bind(this);
		this.updateListener();

		if (this.state.kaarten.length > 0)
			this.renderComplete();
	}

	componentDidUpdate(){
		// NOTE: lijkt niet nodig? Niet in voorbeeld op https://reactjs.org/docs/integrating-with-other-libraries.html
		// this.fullUpdate = this.fullUpdate.bind(this);
		this.updateListener();

		if (this.state.kaarten.length > 0)
			this.renderComplete();
	}

	componentWillUnmount(){
		if (this.state.debug)
			console.log('componentWillUnmount - $.off(ds-crm-react-full-update)', $(`#lijst-${this.props.parent}`))

		// Event listener voor update triggers loskoppelen
		$(`#lijst-${this.props.parent}`).off('ds-crm-react-full-update', this.fullUpdate)
	}

	renderComplete(){
		if (this.state.debug)
			console.log('renderComplete - trigger ds-crm-web-component-geladen');

		// Trigger geven dat web component is geladen voor verdere initialisatie van bijv. custom selects
		$(document)[0].dispatchEvent(
			new Event('ds-crm-web-component-geladen', {
				bubbles: true,
				composed: true,
			}),
		);
	}

	updateListener(event) {
		if (this.state.debug)
			console.log('ds-crm-react-full-update - updatelistener - $.on(ds-crm-react-full-update)', $(`#lijst-${this.props.parent}`), event)

		// Event listener voor update triggers registreren
		$(`#lijst-${this.props.parent}`).on('ds-crm-react-full-update', this.fullUpdate)
	}

	fullUpdate(event){
		if (event.target.matches(`#lijst-${this.props.parent}`) && timestampLastUpdate !== event.timeStamp){
			if (this.state.debug)
				console.log('fullUpdate')

			this.restRequest();

			timestampLastUpdate = event.timeStamp;
		}
	}

	restRequest(){
		var parent = this.props.parent;

		// Kaarten ophalen
		getKaarten( parent )
			.then(json => {
				this.setState({ kaarten: json });
			})
			.then(json => {
				// this.setState({ loading: false })
				setTimeout(() => this.setState({ loading: false }), window.loadingTimeout);
			});
	}

	render(){
		if (process.env.NODE_ENV === "development") {
			return (
				<React.Fragment>
					<button id="refresh-alle-kaarten"
						data-id={this.props.parent}
					>REFRESH ALLES</button>
					<button className="kaart-refresh"
						data-id={this.state.kaarten.length > 0 ? this.state.kaarten[0].id : 'niet bekend'}
					>REFRESH 1E KAART IN LIJST</button>
					<button className="kaart-refresh"
						data-id={this.state.kaarten.length > 1 ? this.state.kaarten[1].id : 'niet bekend'}
					>REFRESH 2E KAART IN LIJST</button>

					<h1>Bord kaarten:</h1>
					<section id={`lijst-${this.props.parent}`}>
						{this.state.loading && <KaartenPlaceholder/>}
						{!this.state.loading && this.state.kaarten.map((post, index) =>
							<BordKaartenSingleKaart key={`BordKaartenSingleKaart-${post.id}-${Date.now()}`}
								post={post}
								template={this.state.template}
							/>
						)}
					</section>
				</React.Fragment>
			)
		} else {
			return (
				<React.Fragment>
					{this.state.loading && <KaartenPlaceholder/>}
					<section id={`lijst-${this.props.parent}`}>
						{!this.state.loading && this.state.kaarten !== undefined && this.state.kaarten.map((post, index) =>
							<BordKaartenSingleKaart key={`BordKaartenSingleKaart-${post.id}-${Date.now()}`}
								post={post}
								template={this.state.template}
							/>
						)}
					</section>
				</React.Fragment>
			)
		}
	}
}

class BordKaartenComponent extends HTMLElement {
	// constructor(){
	// 	super();

	// 	// Do something more
	// }

	connectedCallback(){
		const attNames = this.getAttributeNames();
		var props = [];
		attNames.map((name) => {
			props[name] = this.getAttribute(name);
			return props;
		});

		// // Create a ShadowDOM
		// const root = this; //.attachShadow({ mode: 'open' });

		// // Create a mount element
		// const mountPoint = document.createElement('div');

		// // Place mount element
		// root.appendChild(mountPoint);

		// Render output inside mount element
		const rootMountPoint = ReactDOM.createRoot(this);
		rootMountPoint.render(
			<React.StrictMode>
				<BordKaarten {...props} />
			</React.StrictMode>
		)
	}
}

customElements.define('bord-kaarten', BordKaartenComponent);